var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#FEF2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6654 13.9987C20.6654 17.6807 17.6807 20.6654 13.9987 20.6654C10.3167 20.6654 7.33203 17.6807 7.33203 13.9987C7.33203 10.3167 10.3167 7.33203 13.9987 7.33203C17.6807 7.33203 20.6654 10.3167 20.6654 13.9987ZM17.2694 18.212C16.2433 19.0092 14.9614 19.4044 13.6646 19.3233C12.3678 19.2422 11.1451 18.6905 10.2263 17.7717C9.30745 16.853 8.75562 15.6304 8.67444 14.3336C8.59325 13.0367 8.98829 11.7549 9.78536 10.7287L17.2694 18.212ZM18.212 17.2694L10.728 9.78536C11.7541 8.98768 13.0362 8.59214 14.3334 8.67305C15.6306 8.75397 16.8536 9.30578 17.7726 10.2248C18.6916 11.1438 19.2434 12.3668 19.3243 13.664C19.4053 14.9612 19.0097 16.2433 18.212 17.2694Z",
    fill: "#F20000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashOff);
export default __webpack_public_path__ + "static/media/Dash-Off.2058595c4779ab0f74bc08accfe22561.svg";
export { ForwardRef as ReactComponent };